var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "portlet-body form" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loading !== 0,
              expression: "loading !== 0"
            }
          ],
          staticClass: "row"
        },
        [
          _c("div", { staticClass: "col-sm-12" }, [
            _c(
              "span",
              [
                _c(
                  "div",
                  {
                    staticClass: "progress",
                    staticStyle: { margin: "20px 0" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "progress-bar",
                        style: { width: _vm.currentProgress + "%" },
                        attrs: {
                          "aria-valuemax": _vm.progress,
                          "aria-valuenow": _vm.loading,
                          "aria-valuemin": "0",
                          role: "progressbar"
                        }
                      },
                      [
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v(_vm._s(_vm.currentProgress) + "% Complete")
                        ])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("h2", [
                  _vm._v(_vm._s(_vm.trans("form.please_wait")) + "...")
                ]),
                _vm._v(" "),
                _c("ring-loader")
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.meals, function(meal, mealDate, index) {
        return [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.loading === 0,
                  expression: "loading === 0"
                }
              ],
              key: index
            },
            [
              _c("div", { staticClass: "row show-block-button" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-md-6",
                    staticStyle: { "padding-left": "0" }
                  },
                  [
                    _c("h3", [
                      _vm._v(
                        "\n            " +
                          _vm._s(mealDate) +
                          "\n            " +
                          _vm._s(_vm.getDayNameFromDate(mealDate)) +
                          "\n            ("
                      ),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip.top",
                              value: _vm.trans("menu_planner.uniq_meal_count"),
                              expression:
                                "trans('menu_planner.uniq_meal_count')",
                              modifiers: { top: true }
                            }
                          ]
                        },
                        [_vm._v(_vm._s(_vm.countUniqMeals(mealDate)))]
                      ),
                      _vm._v(")\n          ")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col-md-6",
                    staticStyle: { "padding-right": "0" }
                  },
                  [
                    _vm.isGranted()
                      ? _c("div", { staticClass: "btn-set pull-right" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn green",
                              on: {
                                click: function($event) {
                                  return _vm.editMenu(mealDate)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.trans("menu_planner.edit")))]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isGranted()
                      ? _c(
                          "div",
                          {
                            staticClass: "btn-set pull-right",
                            staticStyle: { "margin-right": "8px" }
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-default",
                                on: {
                                  click: function($event) {
                                    return _vm.showControlReport(mealDate)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.trans("menu_planner.control_report")
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "btn-set pull-right",
                        staticStyle: { "margin-right": "8px" }
                      },
                      [
                        _c("menu-planner-history", {
                          attrs: {
                            brand: _vm.brand,
                            date: mealDate,
                            "route-name":
                              "api_get_entity_logger_show_menu_planner_serving"
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row", staticStyle: { "margin-top": "20px" } },
                [
                  _c("div", { staticClass: "col-sm-12" }, [
                    _c(
                      "table",
                      {
                        staticClass: "table table-bordered",
                        staticStyle: { "margin-bottom": "0" },
                        attrs: { id: "menu-planner-table-show" }
                      },
                      [
                        _c(
                          "tbody",
                          [
                            _c(
                              "tr",
                              [
                                _c(
                                  "td",
                                  {
                                    staticClass: "menu-header",
                                    staticStyle: {
                                      width: "75px",
                                      "min-width": "75px"
                                    }
                                  },
                                  [_vm._v(" ")]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.mealTypes, function(
                                  mealType,
                                  typeIndex
                                ) {
                                  return _c(
                                    "td",
                                    {
                                      key: typeIndex,
                                      staticClass: "menu-header",
                                      staticStyle: {
                                        width: "150px",
                                        "min-width": "150px"
                                      }
                                    },
                                    [_c("b", [_vm._v(_vm._s(mealType.name))])]
                                  )
                                })
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.variants, function(
                              variant,
                              variantIndex
                            ) {
                              return _c(
                                "tr",
                                { key: variantIndex },
                                [
                                  _c("td", { staticClass: "menu-header" }, [
                                    _c("b", [_vm._v(_vm._s(variant.name))])
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.mealTypes, function(
                                    mealType,
                                    typeIndex
                                  ) {
                                    return _c(
                                      "td",
                                      { key: typeIndex },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.getMealName(
                                                variant.id,
                                                mealType.id,
                                                mealDate
                                              )
                                            ) +
                                            "\n                "
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "right",
                                              "font-size": "0.8em"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "glyphicon glyphicon-play"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.getProductionCost(
                                                        variant.id,
                                                        mealType.id,
                                                        mealDate
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "text-align": "right",
                                              "font-size": "0.8em"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "glyphicon glyphicon-star"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.getMealAvgRate(
                                                        variant.id,
                                                        mealType.id,
                                                        mealDate
                                                      )
                                                    ) +
                                                    "\n                  "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.getMealBadges(
                                            variant.id,
                                            mealType.id,
                                            mealDate
                                          ),
                                          function(badge) {
                                            return _c(
                                              "div",
                                              {
                                                key: badge.id,
                                                staticStyle: {
                                                  "text-align": "right",
                                                  "font-size": "0.8em",
                                                  "font-weight": "bold"
                                                }
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    on: {
                                                      click: function($event) {
                                                        $event.preventDefault()
                                                        return _vm.showMealBadge(
                                                          badge.id
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "fa fa-link"
                                                    }),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(badge.name) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  })
                                ],
                                2
                              )
                            })
                          ],
                          2
                        )
                      ]
                    )
                  ])
                ]
              )
            ]
          )
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-20987f61", { render: render, staticRenderFns: staticRenderFns })
  }
}